export enum CustomFormType {
  InactivityMessage,
  AskForEmail,
}
